import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

// --- Sécurité : authentification par cookie de session ---
// Envoie le cookie de session sur chaque requête (même origine en prod).
axios.defaults.withCredentials = true;

// Filet de sécurité : on retire tout identifiant qui traînerait encore dans les
// params d'une requête. L'authentification se fait via le cookie, jamais via l'URL.
axios.interceptors.request.use(function (config) {
  if (config.params) {
    delete config.params.login;
    delete config.params.password;
  }
  return config;
});

// Session expirée / non authentifié -> nettoyage + retour à la page de connexion.
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      try { localStorage.clear(); } catch (e) { /* noop */ }
      store.commit("clearConnected");
      if (router.currentRoute.name !== "Connection") {
        router.push({ name: "Connection" });
      }
    }
    return Promise.reject(error);
  }
);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");